var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"filter-item mr-2 mb-1"},[_vm._v(" "+_vm._s(_vm.filterVal)+" "),_c('VueIcon',{staticClass:"ml-1",attrs:{"name":"times"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }